import { GameSceneMVC } from '../../game/scene/GameSceneMVC';
import type { Scene, SceneManager } from '../SceneManager';
import { createDiv } from '../../libs/HTML/HTMLElementCreator';

let clearPreviousOne: (() => void) | null = null;

export function showLevelTimer(sceneManager: SceneManager): void {
  clearPreviousOne?.();

  const panel = createDiv({
    parentElement: document.body,
    elementID: 'level-timer-debug-panel',
    style: {
      position: 'fixed',
      right: '0%',
      bottom: '100px',
      minWidth: '100px',
      margin: '5px 5px 5px 5px',
      padding: '5px 5px 5px 5px',
      backgroundColor: '#aaaaaa',
    },
  });

  let startDate: number | null = Date.now();

  function formatTime(timeMs: number): string {
    const timeSec = Math.floor(timeMs / 1000);

    const min = `${Math.floor(timeSec / 60)}`.padStart(2, '0');
    const sec = `${timeSec % 60}`.padStart(2, '0');
    return `${min}:${sec}`;
  }

  const intervalId = setInterval(() => {
    if (startDate === null || panel === null) return;
    panel.innerText = formatTime(Date.now() - startDate);
  }, 100);

  clearPreviousOne = (): void => {
    panel.remove();
    clearInterval(intervalId);
  };

  const onSceneActivated = (scene: Scene): void => {
    const isReplay = scene instanceof GameSceneMVC && !scene.options.saveProgress;
    if (isReplay) {
      showLevelTimer(sceneManager);
    } else {
      startDate = null;
    }
    sceneManager.onSceneActivated.disconnect(onSceneActivated);
  };

  sceneManager.onSceneActivated.connect(onSceneActivated);
}
